import { useState } from "react";
import {
  Alert,
  ButtonBase,
  IconButton,
  List,
  Stack,
  Typography,
} from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { KeyboardArrowDown } from "@mui/icons-material";

const LoyaltyLevelStep = ({ state, setState }) => {
  const GradientIcon = ({ level }) => {
    const gradientId = `gradient-${level}`;

    const gradients = {
      Azul: (
        <>
          <stop offset="0%" stopColor="#00BBEE" />
        </>
      ),
      Plata: (
        <>
          <stop offset="0%" stopColor="#a8a8a8" />
          <stop offset="50%" stopColor="#bfbfbf" />
          <stop offset="100%" stopColor="#a8a8a8" />
        </>
      ),
      Oro: (
        <>
          <stop offset="0%" stopColor="#e1ad01" />
          <stop offset="50%" stopColor="#ffcc00" />
          <stop offset="100%" stopColor="#e1ad01" />
        </>
      ),
    };

    return (
      <>
        <svg width={0} height={0}>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            {gradients[level]}
          </linearGradient>
        </svg>
        <WorkspacePremiumIcon sx={{ fill: `url(#${gradientId})` }} />
      </>
    );
  };

  return (
    <>
      <TitleHeaders
        title={"¿Recuerdas nuestro programa de lealtad?"}
        subtitle={"Nos encantaría repasar contigo sus beneficios."}
      />
      <Typography variant="h6" display={"flex"} alignItems={"center"}>
        Tu Nivel Actual:
        <GradientIcon level={state.levelName} />
        {`${state.levelName}`}
      </Typography>

      <Typography variant="body1" gutterBottom>
        {state.level === 3
          ? `¡Ya estás en el nivel más alto!`
          : `¡Solo te faltan ${
              state.monthsToNextLevel || 1
            } meses para alcanzar el nivel ${state.nextLevel}!`}
      </Typography>

      <Typography variant="h6" sx={{ marginTop: "20px" }}>
        {`${
          state.level === 1
            ? `En el nivel Plata tendras los siguientes beneficios:`
            : `Beneficios actuales de nivel ${state.levelName}:`
        } `}
      </Typography>
      <List>
        {Boolean(state?.benefitsFromlevel?.length > 0) &&
          state?.benefitsFromlevel.map((benefit, index) => (
            <ListItemElement
              key={benefit.name}
              title={benefit.name}
              description={benefit.description}
              startIcon={benefit.icon}
              whatsappRedirect={benefit.whatsappRedirect}
            />
          ))}
      </List>

      <Alert severity="warning" sx={{ marginTop: 2 }}>
        Importante: Si cancelas ahora, perderás todos estos beneficios y
        cualquier progreso hacia el siguiente nivel. Queremos que sigas
        disfrutando de estas ventajas increíbles que te has ganado.
      </Alert>
    </>
  );
};

const ListItemElement = ({
  title,
  subtitle,
  startIcon = null,
  endIcon = null,
  description = null,
  onClick = null,
  whatsappRedirect = null,
  email = null,
  descriptionFunc = null,
  vehicles = [],
  uid = null,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  function toggleVisibility() {
    setIsOpen((prev) => !prev);
  }
  const isClickable = description || onClick;
  const BaseComponent = isClickable ? ButtonBase : Stack;
  return (
    <BaseComponent
      {...rest}
      sx={{
        display: "flex",
        alignItems: "",
        flexDirection:
          description || descriptionFunc || vehicles.length > 0
            ? "column"
            : "row",
        justifyContent: "flex-start",
        background: "white",
        borderRadius: "10px",
        border: "1px solid #8A8A8A",
        marginBottom: "5px",
        width: "100%",
      }}
    >
      <Stack
        onClick={
          description || descriptionFunc || vehicles.length > 0
            ? toggleVisibility
            : onClick
        }
        sx={{
          width: "100%",
          p: 2,
          boxSizing: "border-box",
        }}
        direction="row"
        alignItems="center"
        spacing={2}
      >
        {startIcon}
        <Stack sx={{ flex: "1", alignItems: "flex-start", textAlign: "left" }}>
          <Typography sx={{ fontSize: ["0.85rem", "1rem"], fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: ["0.85rem", "1rem"],
              textAlign: "left",
              color: "#8A8A8A",
            }}
          >
            {subtitle}
          </Typography>
        </Stack>
        {endIcon ? (
          endIcon
        ) : description || descriptionFunc || vehicles.length > 0 ? (
          <IconButton>
            <KeyboardArrowDown
              sx={{
                transform: isOpen ? "rotate(180deg)" : "",
                transition: "transform ease 500ms ",
              }}
            />
          </IconButton>
        ) : null}
      </Stack>
      {(description || descriptionFunc || vehicles.length > 0) && (
        <Stack
          sx={{
            textAlign: "left",
            width: "100%",
            borderTop: "1px solid #8A8A8A",
            p: isOpen ? 2 : "",
            boxSizing: "border-box",
            overflow: "hidden",
            height: isOpen ? "" : "0px",
            display: isOpen ? "" : "none",
            transition: "all ease 500ms ",
            whiteSpace: "pre-wrap",
          }}
        >
          <Typography sx={{ color: "#8A8A8A" }}>
            {description || descriptionFunc}
          </Typography>
        </Stack>
      )}
    </BaseComponent>
  );
};

export default LoyaltyLevelStep;
